import { headingVariantClassName } from "@/components/ui/heading";
import { cn } from "@/lib/utils";

const shellPadX = "px-4 sm:px-6 lg:px-8";

/** App-wide elevated surface — border on card surfaces (avoid ring; rings clip under overflow). */
export const elevatedSurfaceClassName = "rounded-xl border border-border bg-card";

/** Rounded elevated surface — same token as filter bars and list grid rows. */
export const formFlowSurfaceClassName = cn(elevatedSurfaceClassName, "min-w-0 p-4");

/** Multi-step sidebar — same surface as {@link formFlowSurfaceClassName}. */
export const formFlowStepsColumnClassName = formFlowSurfaceClassName;

/** Vertical gap between stacked FormFlow section surfaces (details + review boxes). */
export const formFlowSectionsGapClassName = "gap-4";

/** Details step field stack inside {@link FormFlow} (avoid nesting {@link formFlowSurfaceClassName}). */
export const formFlowDetailsStepClassName = cn("flex flex-col", formFlowSectionsGapClassName);

/** Subsection surface (e.g. accordion panels) — same chrome as {@link formFlowSurfaceClassName}. */
export const formFlowSectionClassName = formFlowSurfaceClassName;

/** Review step wrapper. */
export const formFlowReviewStepClassName = "space-y-4";

/** Edit-mode review change card. */
export const formFlowEditReviewItemClassName = "rounded-lg border border-border p-4";

/** Compact numeric inputs (progress, etc.). */
export const formFlowNumericInputClassName = "w-28 max-w-full tabular-nums";

/** CEP / postal code — short value; half row so it is not full-bleed. */
export const formFlowCepInputClassName = "w-1/2 max-w-full tabular-nums";

/** Quantity fields with a floating label — wide enough for “Quantidade *”, not full width. */
export const formFlowQuantityInputClassName = "w-44 max-w-full tabular-nums";

/** Decimal inputs with fixed fractional digits (temperature, etc.). */
export const formFlowDecimalInputClassName = "w-32 max-w-full tabular-nums";

/** Hex color text inputs beside a color swatch. */
export const formFlowColorHexInputClassName = "w-36 max-w-full font-mono tabular-nums";

/** Date-only picker inputs — wide enough for `DD/MM/AAAA` plus clear/calendar icons. */
export const formFlowDateInputClassName = "w-48 max-w-full";

/** Date and time picker inputs (`DD/MM/AAAA HH:MM`). */
export const formFlowDateTimeInputClassName = "w-60 max-w-full sm:w-52";

/** Review step heading. */
export const formFlowReviewHeadingClassName = headingVariantClassName.section;

/** Centered column aligned with the form surface chrome. */
export function formFlowChromeColumnClassName(wide: boolean): string {
  return cn("mx-auto w-full min-w-0", wide ? "max-w-6xl" : "max-w-2xl", shellPadX);
}
